import produce from 'immer';
import uniq from 'lodash/uniq';
import uniqBy from 'lodash/uniqBy';
import { addSeconds } from 'date-fns';
import { set, LS_CART_ITEM_PRODUCT_IDS } from '@ts/utils/ls';
import { ActionTypes } from '../actions/cart';

export const initialState = {
    activities: [],
    data: {
        customTotal: null,
        discount: [],
        expireTime: null,
        fixedTime: null,
        hotelsCount: 0,
        id: null,
        lifeTime: 0,
        subTotal: 0,
        subTotalSubunits: 0,
        surcharges: 0,
        surchargesSubunits: 0,
        timeLeft: 0,
        total: 0,
        totalSubunits: 0,
        tripsCount: 0,
    },
    errorMessage: '',
    expireModal: {
        isVisible: false,
    },
    isApplying: false,
    isApplyingError: false,
    isError: false,
    isExtending: false,
    isLoaded: false,
    isLoading: false,
    isOutdatedLoaded: false,
    itemProductIds: [],
    items: [],
    itemsStates: {},
    promocodeValue: '',
    sessionId: '',
};

/* eslint-disable no-param-reassign */
function appCartReducer(state = initialState, action) {
    return produce(state, (draft) => {
        switch (action.type) {
            case ActionTypes.CHANGE_ID:
                draft.data.id = action.id;
                return draft;
            case ActionTypes.CHANGE_IS_EXTENDING:
                draft.isExtending = action.isExtending;
                return draft;
            case ActionTypes.CHANGE_IS_APPLYING:
                draft.isApplying = action.isApplying;
                return draft;
            case ActionTypes.CHANGE_IS_APPLYING_ERROR:
                draft.isApplyingError = action.isApplyingError;
                return draft;
            case ActionTypes.CHANGE_PROMOCODE_VALUE:
                draft.promocodeValue = action.value;
                draft.isApplyingError = false;
                return draft;
            case ActionTypes.CHANGE_EXPIRE_MODAL_IS_VISIBLE:
                draft.expireModal.isVisible = action.isVisible;
                return draft;
            case ActionTypes.CHANGE_LIFE_TIME:
                draft.data.lifeTime = action.lifeTime;
                draft.data.timeLeft = action.timeLeft;
                draft.data.expireTime = addSeconds(new Date(), action.timeLeft).getTime();
                return draft;
            case ActionTypes.CHANGE_ITEM_STATE_IS_CHANGING:
                draft.itemsStates[action.identifier] = draft.itemsStates[action.identifier] || {};
                draft.itemsStates[action.identifier].isChanging = action.isChanging;
                return draft;
            case ActionTypes.CHANGE_ITEM_STATE_IS_REMOVING:
                draft.itemsStates[action.identifier] = draft.itemsStates[action.identifier] || {};
                draft.itemsStates[action.identifier].isRemoving = action.isRemoving;
                return draft;
            case ActionTypes.CHANGE_DATA:
                draft.data.id = action.data.cart_id;
                draft.data.customTotal = action.data.custom_total;
                draft.data.discount = action.data.discount;
                draft.data.hotelsCount = action.data.hotels_count;
                draft.data.lifeTime = action.data.lifetime;
                draft.data.subTotal = action.data.subtotal;
                draft.data.surcharges = action.data.surcharges;
                draft.data.timeLeft = action.data.time_left;
                draft.data.total = action.data.total;
                draft.data.tripsCount = action.data.trips_count;
                draft.data.fixedTime = new Date().getTime();
                draft.data.expireTime = addSeconds(new Date(), action.data.time_left).getTime();
                draft.data.subTotalSubunits = action.data.subtotal_subunits;
                draft.data.surchargesSubunits = action.data.surcharges_subunits;
                draft.data.totalSubunits = action.data.total_subunits;
                return draft;
            case ActionTypes.CONCAT_ACTIVITIES:
                draft.activities = uniqBy(draft.activities.concat(action.activities), 'id');
                return draft;
            case ActionTypes.CLEAR_ACTIVITIES:
                draft.activities = [];
                set(LS_CART_ITEM_PRODUCT_IDS, []);
                return draft;
            case ActionTypes.CHANGE_ITEMS:
                draft.items =
                    draft.items.length === 0 && action.items.length === 0
                        ? draft.items
                        : action.items;
                // eslint-disable-next-line no-case-declarations
                const productIds = draft.items.map((item) => parseInt(item.product_id, 10));
                if (productIds.length > 0) {
                    draft.itemProductIds = uniq(productIds);
                    set(LS_CART_ITEM_PRODUCT_IDS, draft.itemProductIds);
                }
                return draft;
            case ActionTypes.CHANGE_ITEM_PRODUCT_IDS:
                draft.itemProductIds = action.itemProductIds;
                set(LS_CART_ITEM_PRODUCT_IDS, draft.itemProductIds);
                return draft;
            case ActionTypes.REMOVE_ITEM_BY_ID:
                draft.items = draft.items.filter((item) => item.id !== action.identifier);
                draft.itemProductIds = draft.itemProductIds.filter((id) => id !== action.productId);
                draft.activities = draft.activities.filter(
                    (activity) => Number(activity.id) !== action.productId
                );
                set(LS_CART_ITEM_PRODUCT_IDS, draft.itemProductIds);
                return draft;
            case ActionTypes.CHANGE_ERROR_MESSAGE:
                draft.errorMessage = action.errorMessage;
                return draft;
            case ActionTypes.CHANGE_IS_ERROR:
                draft.isError = action.isError;
                return draft;
            case ActionTypes.CHANGE_IS_LOADED:
                draft.isLoaded = action.isLoaded;
                return draft;
            case ActionTypes.CHANGE_IS_LOADING:
                draft.isLoading = action.isLoading;
                return draft;
            case ActionTypes.CHANGE_SESSION_ID:
                draft.sessionId = action.sessionId;
                return draft;
            case ActionTypes.CHANGE_IS_OUTDATED_LOADED:
                draft.isOutdatedLoaded = action.isOutdatedLoaded;
                return draft;

            default:
                return draft;
        }
    });
}

export default appCartReducer;
